import * as Crypto from 'expo-crypto';

import Storage from '../utils/storage';

const DEVICE_ID_KEY = 'vida_biometric_device_id';

let cached: string | null = null;

// device_id claim on biometric grants — Apigee enforces request.device_id ==
// JWT claim on /biometric/exchange, so this IS the device binding. Not
// biometric-gated: we need to read it before prompting biometric on cold start.
export const getOrCreateDeviceId = async (): Promise<string> => {
  if (cached) return cached;
  const stored = await Storage.getItem(DEVICE_ID_KEY);
  if (stored) {
    cached = stored;
    return stored;
  }
  const fresh = Crypto.randomUUID();
  await Storage.setItem(DEVICE_ID_KEY, fresh);
  cached = fresh;
  return fresh;
};

export const __resetDeviceIdCacheForTests = (): void => {
  cached = null;
};
